module.exports = __webpack_public_path__ + "static/media/cridflixx.af07dc2d.jpg";